import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map, filter } from 'rxjs/operators';
import { AppConfiguration, AppConfig } from 'src/configuration';


@Injectable({
  providedIn: 'root'
})
export class ClassService {

  constructor(@Inject(AppConfig) private readonly appConfig: AppConfiguration,
    private http : HttpClient) { }

getClass(req: any, token) : Observable<any>{
  return this.http.post<any>(this.appConfig.UniTeacher + 'Class/ClassListAll',req,{
      headers: new HttpHeaders()
        .set('Authorization', `Bearer ${token}`)
    } ).pipe(map(z=> {return z}))
}

Danh_sach_lop_dang_hoc(): Observable<any> {
  return this.http.get<any>(this.appConfig.UniSystemAPI + 'Lop/Danh_sach_lop_dang_hoc').pipe(map((z) => { return z; }));
}

getTeacherList(req:any, token:any) : Observable<any>{
  return this.http.post<any>(this.appConfig.UniTeacher + 'Class/TeacherListAll', req,{
      headers: new HttpHeaders()
        .set('Authorization', `Bearer ${token}`)
    } ).pipe(map(z=> {return z}))
}
Count(token): Observable<any> {
  return this.http.get<any>(this.appConfig.UniTeacher + 'Class/Count', {
       headers: new HttpHeaders().set('Authorization', `Bearer ${token}`),
    }).pipe(map((z) => {return z;}));
}
CountFilter(req,token): Observable<any> {
  return this.http.post<any>(this.appConfig.UniTeacher + 'Class/CountFilter',req, {
       headers: new HttpHeaders().set('Authorization', `Bearer ${token}`),
    }).pipe(map((z) => {return z;}));
}
getClassStudents(req: any, token) : Observable<any>{
  return this.http.post<any>(this.appConfig.UniTeacher + 'Class/StudentsClassCredit',req,{
    headers: new HttpHeaders()
      .set('Authorization', `Bearer ${token}`)
  } ).pipe(map(z=> {return z}))
}
getClassStudentsNienChe(req: any, token) : Observable<any>{
  return this.http.post<any>(this.appConfig.UniTeacher + 'Class/StudentsClassKeHoach',req,{
    headers: new HttpHeaders()
      .set('Authorization', `Bearer ${token}`)
  } ).pipe(map(z=> {return z}))
}
getClassOnline(req: any, token) : Observable<any>{
  return this.http.post<any>(this.appConfig.UniTeacher + 'Class/ClassListAllOnline',req,{
    headers: new HttpHeaders()
      .set('Authorization', `Bearer ${token}`)
  } ).pipe(map(z=> {return z}))
}

getStudentTruant(req: any, token) : Observable<any>{
  return this.http.post<any>(this.appConfig.UniTeacher + 'Class/StudentTruantListAll',req,{
    headers: new HttpHeaders()
      .set('Authorization', `Bearer ${token}`)
  } ).pipe(map(z=> {return z}))
}
Export_ClassStudents(req: any, token): Observable<any> {
  return this.http.post<any>(this.appConfig.UniTeacher + 'BaoCao/ExportToExcelBaocao_DanhDachLop', req, {
    headers: new HttpHeaders()
      .set('Authorization', `Bearer ${token}`)
  }).pipe(map(z => { return z }))
}
// Export_ClassStudentsNienChe(req: any, token): Observable<any> {
//   return this.http.post<any>(this.appConfig.UniTeacher + 'BaoCao/ExportToExcelBaocao_DanhDachLop', req, {
//     headers: new HttpHeaders()
//       .set('Authorization', `Bearer ${token}`)
//   }).pipe(map(z => { return z }))
// }
Export_ClassStudentsNienChe(req : any, token) : Observable<any>{
  return this.http.post<any>(this.appConfig.UniTeacher + 'BaoCao/ExportToExcelBaocao_DanhDachLop',req,{
    headers: new HttpHeaders()
      .set('Authorization', `Bearer ${token}`)
  } ).pipe(map(z=> {return z}))
}

ClassListFull(token): Observable<any> {
  return this.http.get<any>(this.appConfig.UniTeacher + 'Class/ClassListFull', {
    headers: new HttpHeaders().set('Authorization', `Bearer ${token}`),
  }).pipe(map((z) => { return z; }));
}

getTeacher(token:any) : Observable<any>{
  return this.http.get<any>(this.appConfig.UniTeacher + 'Class/TeacherLoadList', {
      headers: new HttpHeaders()
        .set('Authorization', `Bearer ${token}`)
    } ).pipe(map(z=> {return z}))
}

}
